"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateRange = void 0;
const formatDateRange = (_option, dayjsClass, dayjsFactory) => {
    dayjsClass.prototype.formatDateRange = function (toDate, options) {
        if (!dayjsFactory.isDayjs(toDate)) {
            toDate = dayjsFactory(toDate).locale(this.locale());
        }
        const format = options?.localeShowWeek
            ? 'localeMonthDayWeekNumber'
            : 'monthDay';
        return this.customFormat(format) + ' – ' + toDate.customFormat(format);
    };
};
exports.formatDateRange = formatDateRange;
